import { useMemo } from "react";
import { Provider } from "react-redux";
import Dashboard from "./Dashboard";

export default () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <Dashboard />
    </Provider>
  );
};
